<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();
  interface Props {
    value: any;
    messages?: string[];
    validityClass?: string;
  }

  let { value = $bindable(), messages = [], validityClass = '' }: Props = $props();

  function handleInput(event: Event) {
    dispatch('input', event);
  }
</script>

<div>
  <input type="email" bind:value oninput={handleInput} class={validityClass} />
  {#each messages as message}
    <p>{message}</p>
  {/each}
</div>

<style>
  div {
    display: grid;
    gap: 1ch;
  }

  input {
    font-size: 1rem;
    border-radius: 5px 0 0 5px;
    border: 2px solid black;
    width: 200px;
    font-family: var(--font-family);
    padding-inline: 1ch;
    outline: none;
    height: 48px;
    width: 250px;
  }

  @media screen and (max-width: 768px) {
    input {
      border-radius: 5px;
    }
  }

  input:focus {
    box-shadow: 0 0 3px #000000cc inset;
  }

  p {
    margin: 0;
    color: var(--primaryText);
  }
</style>
